import { cn } from '@/lib/cn';

interface LogoProps {
  size?: 'sm' | 'md';
  showTagline?: boolean;
  className?: string;
}

/**
 * ProjexHQ logo: navy badge with "P" + orange "HQ" overlay,
 * wordmark with two-tone treatment, optional tagline.
 */
export function Logo({ size = 'md', showTagline = true, className }: LogoProps) {
  const badgeSize = size === 'sm' ? 'w-9 h-9 text-xl' : 'w-[42px] h-[42px] text-2xl';
  const wordmarkSize = size === 'sm' ? 'text-lg' : 'text-2xl';

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div
        className={cn(
          'relative flex items-center justify-center rounded-md font-bold text-white shadow-colored bg-brand-navy flex-shrink-0',
          badgeSize,
        )}
      >
        P
        <span className="absolute bottom-0.5 right-0.5 text-[10px] font-bold text-brand-orange bg-white px-[3px] py-[1px] rounded-[2px] leading-none">
          HQ
        </span>
      </div>
      <div className="flex flex-col leading-tight">
        <div className={cn('font-semibold whitespace-nowrap tracking-tight', wordmarkSize)}>
          <span className="text-brand-navy font-medium">Projex</span>
          <span className="text-brand-orange font-bold">HQ</span>
        </div>
        {showTagline && (
          <div className="text-[10px] tracking-[0.15em] uppercase text-ink-quaternary font-semibold whitespace-nowrap -mt-0.5">
            Project Intelligence
          </div>
        )}
      </div>
    </div>
  );
}
